import { z } from 'zod'

// The user's photos an offer is built from. It is shown only while all of them are in the photo bank.
export const CartUpsellOfferBaseSchema = z.object({
  sourcePhotoUids: z.array(z.string()),
})
export type CartUpsellOfferBase = z.infer<typeof CartUpsellOfferBaseSchema>

const CartUpsellGenerationBaseSchema = CartUpsellOfferBaseSchema.extend({
  status: z.literal('generating'),
  jobId: z.string(),
  startedAt: z.number(),
})

// A record this bundle can't read (written by a newer or older schema): hidden, never throws, never regenerates.
const UNREADABLE_CART_UPSELL_RECORD = {
  status: 'failed',
  errorCode: 'unreadable_record',
} as const

// generationFields: what a generating record carries into its offer beyond the source photo uids.
export function createCartUpsellRecordSchema<
  OfferSchema extends z.ZodType<CartUpsellOfferBase>,
  GenerationFields extends z.ZodRawShape,
>(offerSchema: OfferSchema, generationFields: GenerationFields) {
  return z
    .discriminatedUnion('status', [
      z.object({ status: z.literal('pending'), requestedAt: z.number() }),
      // Extended in this order so TS can see the discriminator on a generic shape.
      z.object(generationFields).extend(CartUpsellGenerationBaseSchema.shape),
      z.object({ status: z.literal('offered'), offer: offerSchema }),
      z.object({ status: z.literal('applied') }),
      z.object({ status: z.literal('dismissed') }),
      z.object({ status: z.literal('failed'), errorCode: z.string() }),
    ])
    .catch(UNREADABLE_CART_UPSELL_RECORD)
    .optional()
}
